import { api } from "@/api";

export default {
  getListEndorsement(filter) {
    return api.get(`/v1/garantia/endossos${filter}`);
  },
  getListRequestEndorsement(filter) {
    return api.get(`/v1/garantia/endossos/solicitacoes${filter}`);
  },
  getListTakerEndorsement(grupoEconomicoId) {
    return api.get(
      `/v1/gruposeconomicos/${grupoEconomicoId}/tomadores/endosso`
    );
  }
};
